import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BsArrowsFullscreen, BsPeople } from 'react-icons/bs';

// LIGHTBOX İMPORTLARI
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const Room = ({ room }) => {
  const { id, name, image, size, maxPerson, description, price } = room;
  
  // Lightbox State
  const [open, setOpen] = useState(false);

  let backgroundColor = "bg-white";
  if (name.includes("Pink Home")) {
    backgroundColor = "bg-pink-200";
  } else if (name.includes("Artist Antik")) {
    backgroundColor = "bg-[#d1935a]";
  }

  return (
    <div className={`${backgroundColor} shadow-2xl min-h-[500px] group`}>
      
      {/* Lightbox - Sadece tek bir slide (ana foto) var */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[{ src: image }]}
        render={{
            buttonPrev: () => null, // Geri butonunu gizle
            buttonNext: () => null, // İleri butonunu gizle
        }}
      />

      {/* Fotoğraf Alanı */}
      <div 
        className='overflow-hidden cursor-pointer relative' 
        onClick={() => setOpen(true)}
      >
        <img 
          className='group-hover:scale-110 transition-all duration-500 w-full h-[250px] object-cover' 
          src={image} 
          alt={name}
        />
        {/* Hover Efekti */}
        <div className='absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center'>
            <span className='text-white border border-white px-4 py-2 rounded-full text-sm font-semibold backdrop-blur-sm'>
                RESMİ BÜYÜT
            </span>
        </div>
      </div>

      {/* Details Box */}
      <div className='bg-white shadow-lg max-w-[300px] mx-auto h-[60px] -translate-y-1/2 flex justify-center items-center uppercase font-tertiary tracking-[1px] font-semibold text-base'>
        <div className='flex justify-between w-[80%]'>
          <div className='flex items-center gap-x-2'>
            <div className='text-accent'>
              <BsArrowsFullscreen className='text-[15px]' />
            </div>
            <div className='flex gap-x-1'>
              <div>Alan</div>
              <div className='notranslate'>{size}m2</div>
            </div>
          </div>
          <div className='flex items-center gap-x-2'>
            <div className='text-accent'>
              <BsPeople className='text-[18px]' />
            </div>
            <div className='flex items-center gap-x-1'>
              <div>KİŞİ</div>
              <div>{maxPerson}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Name & Description */}
      <div className='text-center'>
        <Link to={`/room/${id}`}>
          <h3 className='h3'>{name}</h3>
        </Link>
        <p className='max-w-[300px] mx-auto mb-3 lg:mb-6 text-sm text-gray-600'>
            {description.slice(0, 56) + '...'}
        </p>
      </div>

      {/* Rezervasyon Butonu */}
      <Link 
        to={`/room/${id}`} 
        className="btn btn-secondary btn-sm max-w-[240px] mx-auto flex justify-center gap-1 mb-6 transition-all"
      >
        <div>
          <span>Şimdi Rezervasyon Yap </span>
          <span className="notranslate"> {price}</span>
        </div>
      </Link>
    </div>
  );
};

export default Room;